import React, { Component } from 'react';
import OgaSelect from "../elements/OgaSelect";

export default class PaymentCondSelect extends Component {

    constructor(props) {
        super(props);
    }

    handleChange = (paymentCondition) => {
        this.props.handleChange(paymentCondition);
    }

    render() {
        const paymentConditionsCashAndCredit = [
            { value: 'CASH', label: 'Super Contado' },
            { value: 'CREDIT', label: 'Plazo' }

        ];
        const paymentConditionCredit = [
            { value: 'CREDIT', label: 'Plazo' }

        ];

        const paymentConditionCash = [
            { value: 'CASH', label: 'Super Contado' }
        ];

        return (
            <OgaSelect
                disabled={this.props.disabled}
                bsSize="small"
                placeholder="Condición de Pago"
                value={this.props.selection}
                onChange={(paymentCondition) => this.handleChange(paymentCondition)}
                options={this.props.cashSale && this.props.creditSale ? paymentConditionsCashAndCredit : this.props.cashSale ? paymentConditionCash : this.props.creditSale ? paymentConditionCredit : paymentConditionsCashAndCredit }
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PaymentCondSelect/PaymentCondSelect.jsx